import React, { useState, useEffect } from "react";
import confetti from "canvas-confetti";
import { Link } from "react-router-dom";
import { Row, Col, CardBody, Card, Container } from "reactstrap";

const options = [
    "Documented, updated in the last 12 months, and actively used.",
    "Documented,and updated within the last 1-3 years.",
    "Documented,but hasn't been updated in over 3 years.",
    "We don't have a business plan.",
];

const businessPlanOptions = [
    "Documented, updated in the last 12 months, and actively used.",
    "Documented, and updated within the last 1-3 years.",
    "Documented, but hasn't been updated in over 3 years.",
    "We don't have a business plan.",
];

const options2 = [
    "Documented, updated in the last 12 months, and actively used.",
    "Documented, and updated within the last 1-3 years.",
    "Documented, but hasn't been updated in over 3 years.",
    "We don't have a succession plan.",
];

const options4 = [
    "Documented, updated in the last 12 months, and actively used.",
    "Documented, and updated within the last 1-3 years.",
    "Documented, but hasn't been updated in over 3 years.",
    "We don't follow any systems, procedures, or controls.",
];

const options3 = [
    "0% We don't rely on a supplier.",
    "25%",
    "50%",
    "75%",
    "100%",
];

const Step7 = () => {
    const [yesSelected, setYesSelected] = useState(null);
    const [yesSelected2, setYesSelected2] = useState(null);
    const [legalIssue, setLegalIssue] = useState(null);
    const [selected, setSelected] = useState(1);
    const [businessPlan, setBusinessPlan] = useState("");
    const [systemsControl, setSystemsControl] = useState("");
    const [systems, setSystems] = useState("");
    const [suppliers, setSuppliers] = useState("");

    const handleOptionClick = (index) => {
        setSelected(index + 1); // Update selected state based on the option clicked
    };

    const [selectedOption, setSelectedOption] = useState(1);

    const handleSelection = (index) => {
        setSelectedOption(index + 1);
    };

    const [currentSelection, setCurrentSelection] = useState(1);

    const updateSelection = (index) => {
        setCurrentSelection(index + 1);
    };

    const [activeChoice, setActiveChoice] = useState(1);

    const changeChoice = (index) => {
        setActiveChoice(index + 1);
    };

    const launchConfetti = () => {
        confetti({
            particleCount: 200,
            spread: 170,
            origin: { y: 0.6 },
        });
    };

    useEffect(() => {
        launchConfetti();
    }, []);

    const [percentage, setPercentage] = useState(0);

    const containerStyle1 = {
        display: 'flex',
        alignItems: 'left',
        justifyContent: 'left',
        marginTop: '20px',
    };

    const sliderThumb1 = {
        position: 'absolute',
        width: '30px',
        height: '30px',
        backgroundColor: 'white',
        borderRadius: '50%',
        border: '2px solid #77bc4b',
        transition: 'top 0.3s ease, transform 0.2s ease, box-shadow 0.2s ease',
        top: `${(selectedOption - 1) * 80}px`,
        boxShadow: selectedOption <= 4 ? 'rgb(104 200 105 / 50%) 0px 0px 10px' : 'none',
        transform: selectedOption <= 4 ? 'scale(1.1)' : 'scale(1)',
    };

    const sliderThumb2 = {
        position: 'absolute',
        width: '30px',
        height: '30px',
        backgroundColor: 'white',
        borderRadius: '50%',
        border: '2px solid #77bc4b',
        transition: 'top 0.3s ease, transform 0.2s ease, box-shadow 0.2s ease',
        top: `${(currentSelection - 1) * 80}px`,
        boxShadow: currentSelection <= 4 ? 'rgb(255 87 51 / 50%) 0px 0px 10px' : 'none',
        transform: currentSelection <= 4 ? 'scale(1.1)' : 'scale(1)',
    };

    const sliderThumb3 = {
        position: 'absolute',
        width: '30px',
        height: '30px',
        backgroundColor: 'white',
        borderRadius: '50%',
        border: '2px solid #77bc4b',
        transition: 'top 0.3s ease, transform 0.2s ease, box-shadow 0.2s ease',
        top: `${(activeChoice - 1) * 40}px`,
        boxShadow: activeChoice <= 4 ? 'rgb(51 102 255 / 50%) 0px 0px 10px' : 'none',
        transform: activeChoice <= 4 ? 'scale(1.1)' : 'scale(1)',
    };

    const containerStyle = {
        textAlign: 'center',
        fontFamily: 'Arial, sans-serif',
        color: '#111',
        backgroundColor: '#f8f9fa',
        borderRadius: '8px',
    };

    const boldTextStyle = {
        fontWeight: 'bold',
        textDecoration: 'underline',
    };

    const sliderContainerStyle = {
        display: 'flex',
        alignItems: 'left',
        justifyContent: 'left',
        marginTop: '20px',
    };

    const numbersStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        marginRight: '10px',
    };

    const numberContainerStyle = {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '20px',
    };

    const numberStyle = (isActive) => ({
        fontSize: '18px',
        fontWeight: isActive ? 'bold' : 'normal',
        color: isActive ? '#77bc4b' : '#111',
        marginRight: '10px',
    });

    const dashLineStyle = (isActive) => ({
        width: isActive ? '180px' : '150px', // Wider when active
        height: '1px',
        backgroundColor: isActive ? '#77bc4b' : 'gray', // Change color when active
    });

    const sliderStyle = {
        position: 'relative',
        width: '15px',
        height: '270px',
        backgroundColor: '#77bc4b',
        borderRadius: '35px',
        display: 'flex',
        justifyContent: 'center',
    };

    const sliderStyle3 = {
        position: 'relative',
        width: '15px',
        height: '190px',
        backgroundColor: '#77bc4b',
        borderRadius: '35px',
        display: 'flex',
        justifyContent: 'center',
    };

    const sliderBarStyle = {
        position: 'absolute',
        width: '10px',
        height: '350px',
        backgroundColor: 'transparent',
        borderRadius: '10px',
    };

    const sliderThumbStyle = {
        position: 'absolute',
        width: '30px',
        height: '30px',
        backgroundColor: 'white',
        borderRadius: '50%',
        border: '2px solid #77bc4b',
        transition: 'top 0.3s ease, transform 0.2s ease, box-shadow 0.2s ease',
        top: `${(selected - 1) * 80}px`,
        boxShadow: selected === 1 || selected === 2 || selected === 3 || selected === 4 ? 'rgb(104 200 105 / 50%) 0px 0px 10px' : 'none',
        transform: selected === 1 || selected === 2 || selected === 3 || selected === 4 ? 'scale(1.1)' : 'scale(1)',
    };

    const optionsStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginLeft: '20px',
    };

    const optionStyle = (isActive) => ({
        fontSize: '14px',
        maxWidth: '250px',
        transition: 'color 0.3s ease, font-weight 0.3s ease',
        backgroundColor: 'transparent',
        cursor: 'pointer',
        color: isActive ? 'black' : 'lightgray',
        fontWeight: isActive ? 'bold' : 'normal',
    });
    return (
        <React.Fragment>
            <style>
                {`
                input[type="range"] {
                  -webkit-appearance: none;
                  width: 100%;
                  height: 12px;
                  background: #77bc4b;
                  border-radius: 5px;
                  outline: none;
                  transition: 0.3s;
                }

                input[type="range"]::-webkit-slider-runnable-track {
                  width: 100%;
                  height: 6px;
                  background: #77bc4b;
                  border-radius: 5px;
                }

                input[type="range"]::-moz-range-track {
                  width: 100%;
                  height: 6px;
                  background: #77bc4b;
                  border-radius: 5px;
                }

                input[type="range"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  width: 20px;
                  height: 20px;
                  background: white;
                  border: 2px solid #77bc4b;
                  border-radius: 50%;
                  cursor: pointer;
                  margin-top: -7px;
                }

                input[type="range"]::-moz-range-thumb {
                  width: 20px;
                  height: 20px;
                  background: white;
                  border: 2px solid #77bc4b;
                  border-radius: 50%;
                  cursor: pointer;
                }
                `}
            </style>
            <div className="account-pages my-5 pt-sm-5">
                <Container>
                    <Row className="justify-content-center">
                        <Col md={8} lg={8} xl={12}>
                            <Card className="overflow-hidden">
                                <CardBody className="p-4">
                                    <div className="p-3">
                                        <div className="mb-4 p-3 bg-light">
                                            <h5 className="fw-bold">Next, we’ll take a closer look at how your business operates and explore some key details to better understand its structure and setup.</h5>
                                            <p>
                                                Remember, you can pause anytime and pick up where you left off by logging back in.
                                            </p>
                                        </div>
                                        <form className="mt-4" action="#">
                                            <div className="mb-3">
                                                <label className="form-label">Does the business set yearly budget and / or forcasts</label>
                                                <div className="d-flex">
                                                    <button
                                                        type="button"
                                                        className="btn ms-2"
                                                        style={{ backgroundColor: yesSelected === true ? "#77bc4b" : "transparent", border: "1px solid #77bc4b", color: yesSelected === true ? "white" : "#77bc4b" }}
                                                        onClick={() => setYesSelected(true)}
                                                    >
                                                        YES
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn ms-2"
                                                        style={{ backgroundColor: yesSelected === false ? "#77bc4b" : "transparent", border: "1px solid #77bc4b", color: yesSelected === false ? "white" : "#77bc4b" }}
                                                        onClick={() => setYesSelected(false)}
                                                    >
                                                        NO
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="mt-4">
                                                <label className="block mb-4 font-bold text-gray-700">
                                                    What describes your business plan?
                                                </label>
                                                <div className="d-flex gap-3 flex-wrap">
                                                    {businessPlanOptions.map((option, index) => (
                                                        <div
                                                            key={index}
                                                            style={{ width: "220px", height: "200px" }}
                                                            className={`box flex items-center justify-center p-4 w-40 h-20 rounded-lg cursor-pointer ${businessPlan === option
                                                                ? "selected bg-[#A3E566] text-blue"
                                                                : "bg-gray-100 text-black"
                                                                }`}
                                                            onClick={() => setBusinessPlan(option)}
                                                        >
                                                            {option}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            <div className="mt-4">
                                                <label className="block mb-4 font-bold text-gray-700">What best describes your succession plan?</label>
                                                <div className="d-flex gap-3 flex-wrap">
                                                    {options2.map((option, index) => (
                                                        <div
                                                            key={index}
                                                            style={{ width: "220px", height: "200px" }}
                                                            className={`box flex items-center justify-center p-4 rounded-lg cursor-pointer ${systemsControl === option ? "selected bg-[#A3E566] text-blue" : "bg-gray-100 text-black"}`}
                                                            onClick={() => setSystemsControl(option)}
                                                        >
                                                            {option}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            <div className="mt-4">
                                                <label className="block mb-4 font-bold text-gray-700">How would you describe your business systems, procedures, and controls?</label>
                                                <div className="d-flex gap-3 flex-wrap">
                                                    {options4.map((option, index) => (
                                                        <div
                                                            key={index}
                                                            style={{ width: "220px", height: "200px" }}
                                                            className={`box flex items-center justify-center p-4 rounded-lg cursor-pointer ${systems === option ? "selected bg-[#A3E566] text-blue" : "bg-gray-100 text-black"}`}
                                                            onClick={() => setSystems(option)}
                                                        >
                                                            {option}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* <div className="mt-4">
                                                <label className="block mb-4 font-bold text-gray-700">How much of your business’s needs does your major supplier provide?</label>
                                                <div className="d-flex gap-3 flex-wrap">
                                                    {options3.map((option, index) => (
                                                        <div
                                                            key={index}
                                                            style={{ width: "220px", height: "200px" }}
                                                            className={`box flex items-center justify-center p-4 rounded-lg cursor-pointer ${suppliers === option ? "selected bg-[#A3E566] text-blue" : "bg-gray-100 text-black"}`}
                                                            onClick={() => setSuppliers(option)}
                                                        >
                                                            {option}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div> */}

                                            <div className="mb-3 mt-5">
                                                <label className="form-label mt-2" htmlFor="range">
                                                    How much of your business’s needs does your major supplier provide?
                                                </label>
                                                <input
                                                    type="range"
                                                    className="form-range"
                                                    min="0"
                                                    max="100"
                                                    step="25"
                                                    value={percentage}
                                                    onChange={(e) => setPercentage(Number(e.target.value))}
                                                />
                                                <div className="text-center mt-1">{percentage}%</div>
                                            </div>

                                            <div className="mb-3 mt-4">
                                                <label className="form-label">Are there any ongoing legal issues in the business?</label>
                                                <div className="d-flex">
                                                    <button
                                                        type="button"
                                                        className="btn ms-2"
                                                        style={{ backgroundColor: yesSelected2 === true ? "#77bc4b" : "transparent", border: "1px solid #77bc4b", color: yesSelected2 === true ? "white" : "#77bc4b" }}
                                                        onClick={() => setYesSelected2(true)}
                                                    >
                                                        YES
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn ms-2"
                                                        style={{ backgroundColor: yesSelected2 === false ? "#77bc4b" : "transparent", border: "1px solid #77bc4b", color: yesSelected2 === false ? "white" : "#77bc4b" }}
                                                        onClick={() => setYesSelected2(false)}
                                                    >
                                                        NO
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="mb-3 mt-4">
                                                <label className="form-label">Does the business own any registered trademarks?</label>
                                                <div className="d-flex">
                                                    <button
                                                        type="button"
                                                        className="btn ms-2"
                                                        style={{ backgroundColor: legalIssue === true ? "#77bc4b" : "transparent", border: "1px solid #77bc4b", color: legalIssue === true ? "white" : "#77bc4b" }}
                                                        onClick={() => setLegalIssue(true)}
                                                    >
                                                        YES
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn ms-2"
                                                        style={{ backgroundColor: legalIssue === false ? "#77bc4b" : "transparent", border: "1px solid #77bc4b", color: legalIssue === false ? "white" : "#77bc4b" }}
                                                        onClick={() => setLegalIssue(false)}
                                                    >
                                                        NO
                                                    </button>
                                                </div>
                                                {legalIssue && (
                                                    <div className="mb-3">
                                                        <input
                                                            type="text"
                                                            className="form-control mt-3"
                                                            placeholder="Please describe the legal issues"
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                            {/* <div className="mb-3 row">
                                                <div className="col-12 text-end">
                                                    <button className="btn btn-primary w-md waves-effect waves-light" type="submit">Submit</button>
                                                </div>
                                            </div> */}
                                        </form>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Step7;
